import { useMemo } from 'react';
import { Property } from '../api/properties/types';
import { useUser } from '../api/user/useUser';
import { navConfig } from '../components/Navigation/navConfig';
import { useWeeklySummaryStatus } from './useWeeklySummaryStatus';

type NavBadges = Partial<Record<keyof typeof navConfig, number | boolean>>;

interface UseNavBadgesProps {
  property?: Property;
}

export const useNavBadges = ({ property }: UseNavBadgesProps = {}): NavBadges => {
  const { user } = useUser();
  const propertyId = user?.propertyIds?.[0];

  const { hasUnviewedWeeklySummary } = useWeeklySummaryStatus({ propertyId, property });

  return useMemo(() => ({ energy: hasUnviewedWeeklySummary }), [hasUnviewedWeeklySummary]);
};
